import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-calendar-icon lucide-calendar",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M8 2v4" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 2v4" }),
		/* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			x: 3,
			y: 4,
			rx: 2
		}),
		/* @__PURE__ */ _jsx("path", { d: "M3 10h18" })
	]
});
export default SvgCalendar;
